// Studyo Today Backend
// Package studyo.today.schedules.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schedules/v1/resources/period_schedule_occurrence.proto (package studyo.today.schedules.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_type_dayofweek } from "@buf/googleapis_googleapis.bufbuild_es/google/type/dayofweek_pb.js";

/**
 * Describes the file studyo/today/schedules/v1/resources/period_schedule_occurrence.proto.
 */
export const file_studyo_today_schedules_v1_resources_period_schedule_occurrence = /*@__PURE__*/
  fileDesc("CkRzdHVkeW8vdG9kYXkvc2NoZWR1bGVzL3YxL3Jlc291cmNlcy9wZXJpb2Rfc2NoZWR1bGVfb2NjdXJyZW5jZS5wcm90bxIjc3R1ZHlvLnRvZGF5LnNjaGVkdWxlcy52MS5yZXNvdXJjZXMiqwEKGFBlcmlvZFNjaGVkdWxlT2NjdXJyZW5jZRIaChJwZXJpb2Rfc2NoZWR1bGVfaWQYASABKAkSEwoJY3ljbGVfZGF5GAIgASgFSAASLQoLZGF5X29mX3dlZWsYAyABKA4yFi5nb29nbGUudHlwZS5EYXlPZldlZWtIABIQCghyZXZpc2lvbhgEIAEoBRIVCg1zaG91bGRfZGVsZXRlGAUgASgIQgYKBHdoZW5CK6oCKFN0dWR5by5Ub2RheS5TY2hlZHVsZXMuR3JwYy5WMS5SZXNvdXJjZXNiBnByb3RvMw", [file_google_type_dayofweek]);

/**
 * Describes the message studyo.today.schedules.v1.resources.PeriodScheduleOccurrence.
 * Use `create(PeriodScheduleOccurrenceSchema)` to create a new message.
 */
export const PeriodScheduleOccurrenceSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schedules_v1_resources_period_schedule_occurrence, 0);

